import React, { PropsWithChildren } from 'react';
import { Cell } from '../grid/Cell';
import { Grid } from '../grid/Grid';
import styles from './FilePreview.module.scss';

export const FilePreview = ({ name, url, children }: Props) => {

    return (
        <div className={styles.container}>
            <Grid align='center' justify='between' gap='m'>
                <Cell fit>
                    <img src={url} className={styles.image} alt='' />
                </Cell>

                <Cell className={styles.fileNameCell}>
                    <h3 className={styles.fileName}>{name}</h3>
                </Cell>

                <Cell fit>
                    {children}
                </Cell>
            </Grid>
        </div>
    );
};

type Props = PropsWithChildren<{
    name: string;
    url: string;
}>;